import { BentoColumn, BentoColumnProps } from '../../components/Bento/Bento'
import { createWidget } from '../widget-utils'

interface BentoColumnWidgetProps extends BentoColumnProps {
  isLoading?: boolean
}

export const BentoColumnWidget = ({
  isLoading,
  ...props
}: BentoColumnWidgetProps) => <BentoColumn {...props} />

export const BentoColumnWidgetDefinition = createWidget(BentoColumnWidget, {
  type: 'BentoColumn',
})
